import React from 'react'

const RequestIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="20px"
      height="20px"
      fill="blueviolet"
      viewBox="0 0 1000.000000 1000.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,1000.000000) scale(0.100000,-0.100000)"
        fill="blueviolet"
        stroke="none"
      >
        <path d="M6420 7973 l0 -952 -32 -5 c-18 -3 -60 -8 -93 -11 -91 -9 -355 -53 -485 -81 -716 -153 -1301 -411 -1710 -752 -426 -355 -753 -943 -945 -1697 -82 -323 -141 -668 -165 -960 -6 -77 -13 -156 -15 -175 l-4 -35 19 25 c10 14 53 72 96 130 42 58 130 168 194 245 470 563 971 969 1446 1168 165 70 434 131 689 157 232 24 746 8 944 -30 29 -5 55 -10 57 -10 2 0 5 -433 6 -962 l3 -962 175 200 c96 110 687 783 1312 1495 625 711 1137 1298 1138 1303 1 4 -413 459 -921 1009 -508 551 -1092 1183 -1298 1406 -205 224 -382 415 -392 426 -19 19 -19 1 -19 -932z" />
        <path d="M1020 4236 l0 -3244 213 -6 c223 -6 6639 -28 6644 -22 2 1 2 647 1 1435 l-3 1431 -397 -432 -397 -433 -1 -612 0 -613 -2615 0 -2615 0 0 2470 0 2470 893 0 894 0 109 98 c80 72 689 614 779 694 5 4 -782 8 -1748 8 l-1757 0 0 -3244z" />
      </g>
    </svg>
  )
}

export default RequestIcon
